import { locationsService } from "@/apis/services"
import { ILocation, IPaginationMeta, IPaginationParamV2 } from "@/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface ILocationState {
  locations: ILocation[]
  meta?: IPaginationMeta
  isLoading: boolean
  error: string | null
  fetchLocations: (params: IPaginationParamV2) => Promise<void>
}

const initialState = {
  locations: [],
  meta: undefined,
  isLoading: false,
  error: null,
}

export const useLocationsStore = create<ILocationState>()(
  devtools(set => ({
    ...initialState,

    fetchLocations: async (params: IPaginationParamV2) => {
      set({ isLoading: true, error: null })
      try {
        const response = await locationsService.getLocations(params)
        set({ locations: response.data.items, meta: response.data.meta })
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occurred"
        set({ error: errorMessage })
        throw error
      } finally {
        set({ isLoading: false })
      }
    },
  }))
)
